import React from "react";
import { Helmet } from "react-helmet";
import PrivacyPolicy from "../Components/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Vangal Dairies</title>
        <meta
          name="description"
          content="Read the Privacy Policy of Vangal Dairies & Gopika Agro Products Pvt. Ltd. Learn how we collect, use, protect, and manage your personal information."
        />
      </Helmet>

      <PrivacyPolicy />
    </>
  );
};

export default PrivacyPolicyPage;
